import { defineMessages } from 'react-intl'

export const textFieldMessages = defineMessages({
  placeholder: {
    id: 'textField.placeholder',
    description: 'Default paceholder for Text input',
    defaultMessage: 'Text',
  },
})
